import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=5a20cd11&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/sidebar/sidebar.scss?vue&type=style&index=0&id=5a20cd11&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20cd11",
  null
  
)

export default component.exports